export function getPrivacyPolicyUrl(lang: string): string {
    switch (lang) {
        case "cs":
            return "https://www.grid.online/zasady-ochrany-osobnich-udaju";
        default:
            return "https://www.grid.online/zasady-ochrany-osobnich-udaju";
    }
}
